import { EColors2, EFonts, EVariables } from 'libs/styles/styling';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    number?: number;
    title: string;
    className?: string;
}

export const SplitTitle = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);

    return (
        <S_SplitTitle className={props.className}>
            <S_TitleRow>
                {!!props.number && !ctxEventView?.eventData?.eventInfo?.noNumbers && (
                    <S_Number>{props.number}</S_Number>
                )}
                <S_Title>{props.title}</S_Title>
            </S_TitleRow>
        </S_SplitTitle>
    );
};

const S_SplitTitle = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    position: relative;
`;

const S_Title = styled.div`
    color: ${EColors2.DARK};
    font-family: ${EFonts.Bold};
    font-size: 32px;
    letter-spacing: ${EVariables.Spacing};
    @media only screen and (min-width: 1260px) {
        font-size: 37px;
    }
`;

const S_TitleRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 15px;
    justify-content: center;
`;

const S_Number = styled.div`
    background-color: #eaf0f5;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-family: ${EFonts.InterSemiBold};
`;
